import { useQuery } from '@tanstack/react-query';
import { getEntitlements } from '../api/entitlements/getEntitlements';
import { Entitlement } from '../@types/entitlement';

type EntitlementsQueryState = {
  initializing: boolean;
  isError?: boolean;
  entitlements?: Entitlement[];
};

export const useGetEntitlements = (): EntitlementsQueryState => {
  const { isLoading, data, isError } = useQuery({
    queryKey: ['entitlements'],
    queryFn: getEntitlements,
  });

  return {
    initializing: isLoading || isError,
    isError,
    entitlements: data,
  };
};
